import { Form } from 'antd';
import styled from 'styled-components';

import { Text } from '@atom/typography/typography';

export const LabelText = styled(Text)``;

export const LabelStyled = styled(Form.Item)`
  & .ant-form-item-explain-error,
  & .ant-form-item-explain,
  & ${LabelText} {
    font-size: 12px;
  }

  & .ant-form-item-label {
    padding: 0 0 4px 0;
  }
`;
